<template>
    <div>
        <q-table
            :data="modules"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-mt-md"
            >
            <template slot="top" slot-scope="props" :props="props">
                <div class="col" />
                <q-btn color="secondary" icon="fas fa-plus" :label="$t('new_f')" @click="showModuleModal(0)" :disable="!managerTrainings"/>
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="group_training_module_type" :props="props">
                    <q-icon :name="getIconName(props.row.group_training_module_type)" size="1.2rem" /> {{ $t(getModuleType(props.row.group_training_module_type)) }}
                </q-td>

                <q-td key="qty_views" :props="props">
                    {{ props.row.qty_views }}
                </q-td>

                <q-td auto-width key="status" :props="props">
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="avaliable_in" :props="props">
                    {{ props.row.avaliable_in }}
                </q-td>

                <q-td key="module_score" :props="props">
                    {{ props.row.module_score }}
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="fas fa-pencil-alt" @click="showModuleModal(props.row.actions)" :disable="!managerTrainings">
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" :disable="!managerTrainings">
                        <q-tooltip>
                            {{ $t('delete_tooltip')}}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="fas fa-chevron-left" @click="$router.push({ name: 'admin_trainings' })" />
            </div>
        </div>

        <q-modal v-model="module_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @hide="clearModuleModal()">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="module_modal = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('module') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-12">

                        </div>

                        <div :class="id_module === 0 ? 'col-xs-10 col-sm-10' : 'col-xs-12 col-sm-12'">
                            <q-select v-model="group_training_module_type" :disable="(qty_views> 0 || qty_progress > 0) && getContentType === 'video'" :options="moduleTypes" :float-label="$t('content_type')" :error="$v.group_training_module_type.$error" @input="$v.group_training_module_type.$touch" :display-value="selectedModuleType" />
                        </div>

                        <div class="col-xs-2 col-sm-2 self-end" v-if="id_module === 0">
                            <q-btn small class="full-width" @click="showClassesDataBaseModal()" :label="$t('import_modules_database')" />
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <q-field :count="256">
                                <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                            </q-field>
                        </div>

                        <div class="col-xs-12 col-sm-6" v-if="showUploader">
                            <p class="caption">{{ $t('file') }}</p>
                            <uploader :content_type="getContentType" :is_classroom="true" :disable="(qty_views > 0 || qty_progress > 0 && id_module !== 0) && getContentType === 'video'" @fileUploaded="fileUploaded" :multiple="false" :cropper="false" :error="$v.file_url.$error" @input="$v.file_url.$touch" />

                            <p v-if="file_url" class="q-mt-md file-url">
                                <q-icon name="fas fa-check" color="positive" />
                                <a :href="file_complete_url" target="_blank"> {{ $truncateLink(file_url) }}</a>
                            </p>
                        </div>

                        <div class="col-sm-6" v-if="showUploader">
                        </div>

                        <div class="col-xs-12 col-sm-12" v-if="showEmbed">
                            <q-field :helper="$t('embed_help')">
                                <q-input v-model="embed" :float-label="$t('embed')" :error="$v.embed.$error" @input="$v.embed.$touch" />
                            </q-field>
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-datetime v-model="avaliable_in" type="date" :float-label="$t('avaliable_in')" format="DD/MM/YYYY" clearable />
                        </div>

                        <div class="col-xs-12 col-sm-6">
                            <q-field :helper="$t('leave_it_blank_to_use_training_score')">
                                <q-input v-model="module_score" type="number" :float-label="$t('module_score')" :error="$v.module_score.$error" @input="$v.module_score.$touch" />
                            </q-field>
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <p class="caption">{{ $t('status') }}</p>
                            <q-btn-toggle v-model="status" :toggle-color="getColorButtonStatus" :options="statuses" />
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="fas fa-ban" @click="module_modal = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveModule()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-modal v-model="search_classes_database_modal" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @show="clearSelectedClass()" @hide="clearSelectedClass()" no-backdrop-dismiss no-esc-dismiss>

            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="search_classes_database_modal = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('modules') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">

                    <div class="row gutter-sm">
                        <div class="col-xs-12 col-sm-12">
                            <q-input v-model="search_classes_list" :float-label="$t('titles') + ': ' + $t('training') + ', ' + $t('module')" clearable @clear="clearSelectedClass()">
                                <q-autocomplete
                                    @search="searchClassesDataBase"
                                    @selected="selectClassDataBase"
                                    :max-results="25"
                                    :min-characters="3"
                                    :value-field="v => `${ v.id } - ${ v.group_training_module_title }`"
                                />
                            </q-input>
                        </div>
                    </div>

                    <div class="row gutter-sm q-mt-sm" v-if="selected_class.group_training_title !== ''">
                        <div class="col-xs-12 col-sm-12" >
                            <strong>{{ $t('training')}}: </strong>{{ selected_class.group_training_title }}
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <strong>{{ $t('module')}}:  </strong>{{ selected_class.group_training_module_title }}
                        </div>

                        <div class="col-xs-12 col-sm-12">
                            <strong>{{ $t('content_type')}}:  </strong>{{ selected_class.group_training_module_type }}
                        </div>

                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="tertiary" class="full-width" icon="fas fa-ban" :label="$t('cancel')" @click="search_classes_database_modal = false" />
                        </div>

                        <div class="col-xs-12 col-sm-3">
                            <q-btn color="primary" class="full-width" icon="fas fa-file-import" :label="$t('import')" @click="confirmSelectedClass()" :disable="selected_class.group_training_module_title === ''" />
                        </div>
                    </div>

                </div>

            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="confirm_remove" @ok="removeModule()">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props" :props="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeModule()" />
            </template>
        </q-dialog>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Uploader from 'components/Uploader'
import { required, requiredIf, minValue, maxLength } from 'vuelidate/lib/validators'
import { date } from 'quasar'
const { formatDate } = date
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "training", "admin"] },

    props:['managerTrainings'],

    data() {
        return {
            id_training: '',
            id_module: '',
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            modules: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: true,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'modules',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'group_training_module_type',
                    required: true,
                    label: 'content',
                    align: 'left',
                    field: 'group_training_module_type',
                    sortable: true,
                },
                {
                    name: 'qty_views',
                    required: true,
                    label: 'visualizations',
                    align: 'left',
                    field: 'qty_views',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'avaliable_in',
                    required: true,
                    label: 'avaliable_in',
                    align: 'left',
                    field: 'avaliable_in',
                    sortable: true,
                },
                {
                    name: 'module_score',
                    required: true,
                    label: 'module_score',
                    align: 'left',
                    field: 'module_score',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            loading: false,
            confirm_remove: false,
            action_id: '',
            module_types: [],
            module_modal: false,
            title: '',
            group_training_module_type: '',
            qty_views: 0,
            qty_progress: 0,
            status: 1,
            statuses: [
                { label: this.$t('published_f'), value: 1 },
                { label: this.$t('unpublished_f'), value: 2 }
            ],
            file_url: '',
            file_complete_url: '',
            embed: '',
            avaliable_in: null,
            module_score: null,

            // Modal para o clone de provas
            search_classes_database_modal: false,
            selected_class: {
                group_training_title: '',
                group_training_module_title: '',
                group_training_module_type_id: 0,
                group_training_module_type: '',
                group_training_module_type_use_embed: false,
                group_training_module_content: ''
            },
            search_classes_list: []
        }
    },

    components: {
        'uploader': Uploader,
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            group_training_module_types: 'registration_lists/group_training_module_types',
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getContentType() {
            let obj = this.group_training_module_types.find((obj) => { return obj.value === this.group_training_module_type })
            if (obj) return obj.slug
            else return ''
        },

        showUploader() {
            let obj = this.group_training_module_types.find((obj) => { return obj.value === this.group_training_module_type })
            if (obj) return obj.use_embed ? false : true
            else return false
        },

        showEmbed() {
            let obj = this.group_training_module_types.find((obj) => { return obj.value === this.group_training_module_type })
            if (obj) return obj.use_embed
            else return false
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        },

        getColorButtonStatus() {
            if (this.status == 1) return 'positive'
            else return 'negative'
        },

        selectedModuleType() {
            let obj = this.group_training_module_types.find((obj) => { return obj.id === this.group_training_module_type })
            if (obj) return this.$t(obj.slug)
            else return ''
        },

        moduleTypes() {
            let types = []

            this.group_training_module_types.forEach(element => {
                types.push({
                    value: element.value,
                    label: this.$t(element.slug)
                })
            })

            return types
        }
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.$axios.get('/admin_group_trainings/group_trainings/' + this.id_training + '/group_training_modules/?' + this.$qs.stringify(data), this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count
                this.modules = []

                response.data.results.forEach(result => {
                    this.modules.push({
                        id: result.id,
                        title: result.title,
                        group_training_module_type: result.group_training_module_type,
                        qty_views: result.qty_views,
                        status: result.status,
                        avaliable_in: result.avaliable_in ? moment(result.avaliable_in).tz('Etc/GMT').format('DD/MM/YYYY') : '',
                        module_score: result.module_score != 0 ? result.module_score : '',
                        actions: result.id
                    })
                })

                this.loading = false
            })
            .catch(e => {
                this.loading = false
                console.log(e)
            })
        },

        fileUploaded(url) {
            this.file_url = url
            this.file_complete_url = url
        },

        showModuleModal(id) {
            if (id != 0) {
                this.id_module = id
                this.$q.loading.show()

                this.$axios.get(`/admin_group_trainings/group_trainings/${this.id_training}/group_training_modules/${this.id_module}/`, this.getHeader)
                .then(response => {
                    this.title = response.data.title
                    this.group_training_module_type = response.data.group_training_module_type
                    this.status = response.data.status
                    this.qty_views = response.data.qty_views
                    this.qty_progress = response.data.qty_progress
                    this.avaliable_in = response.data.avaliable_in ? moment(response.data.avaliable_in).tz('Etc/GMT').format('YYYY-MM-DDTHH:mm:ss.SSS') : null
                    this.module_score = response.data.module_score != 0 ? response.data.module_score : null
                    if (!this.showEmbed) {
                        this.file_url = response.data.resource
                        this.file_complete_url = response.data.resource_url
                    }
                    else {
                        this.embed = response.data.resource
                    }

                    this.$q.loading.hide()
                    this.module_modal = true
                })
                .catch(e => {
                    this.$q.loading.hide()
                    console.log(e)
                })
            }
            else {
                this.id_module = 0
                this.module_modal = true
            }
        },

        saveModule() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let fd = new FormData()
                fd.append('title', this.title)
                fd.append('group_training_module_type', this.group_training_module_type)
                fd.append('status', this.status)

                if (this.avaliable_in) fd.append('avaliable_in', date.formatDate(this.avaliable_in, 'YYYY-MM-DD'))
                if (this.module_score) fd.append('module_score', this.module_score)

                if (!this.showEmbed) {
                    fd.append('resource', this.file_url)
                }
                else {
                    fd.append('resource', this.embed)
                }

                if (this.id_module != 0) {
                    this.$axios.put(`/admin_group_trainings/group_trainings/${this.id_training}/group_training_modules/${this.id_module}/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.module_modal = false
                        this.request({
                            pagination: this.server_pagination
                        })

                        this.$q.notify({
                            message: this.$t('module_edit_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('module_edit_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })

                        console.log(e)
                    })
                }
                else {
                    this.$axios.post(`/admin_group_trainings/group_trainings/${this.id_training}/group_training_modules/`, fd, this.getHeader)
                    .then(response => {
                        this.$q.loading.hide()
                        this.module_modal = false
                        this.request({
                            pagination: this.server_pagination
                        })

                        this.$q.notify({
                            message: this.$t('module_add_success'),
                            type: 'positive',
                            icon: 'far fa-save'
                        })
                    })
                    .catch(e => {
                        this.$q.loading.hide()

                        this.$q.notify({
                            message: this.$t('module_add_error'),
                            type: 'negative',
                            icon: 'fas fa-ban'
                        })

                        console.log(e)
                    })
                }
            }
            else {
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fas fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        confirmRemove(id) {
            this.action_id = id
            this.confirm_remove = true
        },

        removeModule() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_group_trainings/group_trainings/${this.id_training}/group_training_modules/${this.action_id}/`, this.getHeader)
            .then(response => {
                this.$q.loading.hide()

                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                this.$q.loading.hide()
                console.log(e)
            })
        },

        // Apresenta o modal de importação de aulas
        showClassesDataBaseModal() {
            this.search_classes_database_modal = true
        },

        // Solicita para o servidor a pesquisa de aulas disponíveis para importação
        searchClassesDataBase(terms, done){
            this.$axios.post('/admin_group_trainings/group_trainings/group_training_modules/search_group_training_modules/', {search_module: terms}, this.getHeader)
                .then(response => {
                    let group_training_modules = []
                    response.data.classes.forEach(element => {
                        let regEx = new RegExp(terms, "ig")
                        let replaceMask = '<u>' + terms + '</u>'
                        let group_training_module_title = element.group_training_module_title.replace(regEx, replaceMask)
                        let group_training_title = element.group_training_title.replace(regEx, replaceMask)
                        let group_training_module_type = this.$t(element.group_training_module_type_slug)
                        let lb_class = this.$t('module')
                        let lb_group_training = this.$t('training')
                        let lb_class_type = this.$t('content_type')

                        let option_label = `
                            <strong>${lb_class}: </strong>${group_training_module_title}<br>
                            <strong>${lb_group_training}: </strong>${group_training_title}<br>
                            <strong>${lb_class_type}: </strong>${group_training_module_type}<br>
                        `
                        group_training_modules.push({
                            value: element.id,
                            group_training_title: element.group_training_title,
                            group_training_module_title: element.group_training_module_title,
                            group_training_module_type_id: element.group_training_module_type_id,
                            group_training_module_type: group_training_module_type,
                            group_training_module_type_use_embed: element.group_training_module_type_use_embed,
                            group_training_module_content: element.group_training_module_content,
                            label: option_label,
                            id: element.id
                        })
                    })
                    done(group_training_modules)
                })
                .catch(e => {
                    done([])
                    console.log(e)
                })
        },

        // Carrega o elemento de seleção de uma aula
        selectClassDataBase(item, keyboard) {
            if (!keyboard) {
                this.selected_class.group_training_module_id = item.id
                this.selected_class.group_training_title = item.group_training_title
                this.selected_class.group_training_module_title = item.group_training_module_title
                this.selected_class.group_training_module_type_id = item.group_training_module_type_id
                this.selected_class.group_training_module_type = item.group_training_module_type
                this.selected_class.group_training_module_type_use_embed = item.group_training_module_type_use_embed
                this.selected_class.group_training_module_content = item.group_training_module_content
            }
        },

        // Confirmação de importação de uma aula para o treinamento
        confirmSelectedClass(){
            this.group_training_module_type = this.selected_class.group_training_module_type_id
            this.title = this.selected_class.group_training_module_title
            // Caso a aula não seja um embed, então efetuamos a solicitação de cópia do arquivo para o diretório TMP
            if (this.selected_class.group_training_module_type_use_embed === false) {
                // Solicita a cópia do arquivo para o diretório TMP para carregar o Uploader
                this.$q.loading.show()
                this.$axios.post('/admin_group_trainings/group_trainings/group_training_modules/move_group_training_module_resource_to_tmp/', {group_training_module_source_id: this.selected_class.group_training_module_id}, this.getHeader)
                    .then(response => {
                        this.file_url = response.data.group_training_module_resource
                        this.file_complete_url = response.data.group_training_module_resource
                        this.search_classes_database_modal = false
                    })
                    .catch(e => {
                        if (e.response.status === 400) {
                            this.$q.notify({
                                message: this.$t('module_import_not_found_error'),
                                type: 'negative',
                                icon: 'fas fa-ban'
                            })
                        }
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                    })

            } else {
                // Caso seja um embed
                this.embed = this.selected_class.group_training_module_content
                this.search_classes_database_modal = false
            }
        },

        // Efetua a limpeza do objeto de importação de aulas para o treinamento
        clearSelectedClass() {
            this.selected_class = {
                group_training_title: '',
                group_training_module_title: '',
                group_training_module_type_id: 0,
                group_training_module_type: '',
                group_training_module_type_use_embed: false,
                group_training_module_content: ''
            }
            this.search_classes_list = []
        },

        getModuleType(id) {
            let obj = this.group_training_module_types.find((obj) => { return obj.value === id })
            if (obj) return obj.slug
            else return ''
        },

        getIconName(id) {
            let obj = this.group_training_module_types.find((obj) => { return obj.value === id })
            if (obj) {
                switch(obj.slug) {
                    case 'video': return 'far fa-file-video'
                    break
                    case 'audio': return 'far fa-file-audio'
                    break
                    case 'pdf': return 'far fa-file-pdf'
                    break
                    case 'scorm': return 'fas fa-chalkboard-teacher'
                    break
                    case 'youtube': return 'fab fa-youtube'
                    break
                    case 'vimeo': return 'fab fa-vimeo'
                    break
                    case 'linkedin_slidshare': return 'fab fa-slideshare'
                    break
                }
            }
            else return ''
        },

        getStatus(status) {
            if (status == 1) return 'published_f'
            else if (status == 2) return 'unpublished_f'
            else if (status == 3) return 'deleted'
            else if (status == 4) return 'processing'
            else if (status == 5) return 'processing'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
            else if (status == 4) return 'fas fa-sync fa-spin'
            else if (status == 5) return 'fas fa-sync fa-spin'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
            else if (status == 4) return 'info'
            else if (status == 5) return 'info'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        clearModuleModal() {
            this.title = ''
            this.group_training_module_type = ''
            this.status = 1
            this.file_url = ''
            this.embed = ''
            this.avaliable_in = null
            this.module_score = null
            this.$v.$reset()
        }
    },

    created() {
        this.id_training = this.$route.params.id

        this.request({
            pagination: this.server_pagination
        })
    },

    validations() {
        return {
            title: { required, maxLength: maxLength(256)},
            group_training_module_type: { required },
            file_url: {
                requiredIf: requiredIf(() => {
                    return this.showEmbed ? false : true
                })
            },
            embed: {
                requiredIf: requiredIf(() => {
                    return this.showEmbed
                })
            },
            module_score: {
                minValue: minValue(0)
            }
        }
    }
}
</script>

<style lang="stylus" scoped>
@import '~variables'

.file-url
    a
        text-decoration none
        color black
</style>
